import { render, staticRenderFns } from "./MainWrapper.vue?vue&type=template&id=85ed6d14&scoped=true&"
import script from "./MainWrapper.vue?vue&type=script&lang=js&"
export * from "./MainWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MainWrapper.vue?vue&type=style&index=0&id=85ed6d14&prod&scoped=true&lang=css&"
import style1 from "./MainWrapper.vue?vue&type=style&index=1&id=85ed6d14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ed6d14",
  null
  
)

export default component.exports